<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between">
                        <a-col span="12">
                            <common-page-btn @save="$refs.cultureForm._show()"></common-page-btn>
                        </a-col>
                        <a-col span="12">
                            <a-row type="flex" align="middle" justify="end" :gutter="3">
                                <a-col span="12">
                                    <a-input v-model="param.keyword" allowClear search @pressEnter="getList"
                                             @on-clear="getList" placeholder="关键词查询"></a-input>
                                </a-col>

                            </a-row>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                         :style="{ background: '#FFF' }" size="small" row-key="articleId" border :columns="keys" ref="list"
                         :loading="loading" :data-source="data.records">
                    <!--状态-->
                    <template slot-scope="row" slot="status">
                        <a-tooltip :title="row.status">
                            <template v-if="row.status == '已发布'">
                                <a-icon type="check-circle" style="color:#090" />
                            </template>
                            <template v-else>
                                <a-icon type="stop" />
                            </template>
                        </a-tooltip>
                    </template>
                    <!--置顶-->
                    <template slot-scope="row" slot="top">
                        <template v-if="row.isTop">
                            <a-icon type="check-circle" style="color:#090" />
                        </template>
                        <template v-else>
                            <a-icon type="stop" />
                        </template>
                    </template>
                    <!--操作-->
                    <template slot-scope="row" slot="action">
                        <a-button-group shape="circle" size="small">
                            <a-tooltip title="编辑"><a-button type="link" v-has="'article:culture:save'" icon="edit"
                                          @click="$refs.cultureForm._show(row)"></a-button></a-tooltip>
                            <a-tooltip title="删除"><a-button type="link" v-has="'article:culture:del'" icon="delete"
                                          @click="del(row.articleId)"></a-button></a-tooltip>
                        </a-button-group>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                              @showSizeChange="setLimit" :current="data.current" />
            </a-col>
        </a-row>
        <a-back-top />

        <culture-form ref="cultureForm" @success="doRefresh"></culture-form>
    </div>
</template>

<script>
import utils from '@/common/utils';
import cultureForm from './components/cultureForm.vue';
export default {
    components: { cultureForm },
    data() {
        return {
            loading: false,
            data: [],
            param: {
                page: 1,
                limit: 20,
                depId: '',
                keyword: ''
            },
            keys: [
                { title: 'ID', dataIndex: 'articleId', width: 100, align: 'center' },
                { title: '标题', dataIndex: 'title', align: 'left', width: 200, ellipsis: true },
                { title: '发布人', dataIndex: 'author', width: 100, ellipsis: true },
                { title: '发布时间', dataIndex: 'createTime', width: 200, ellipsis: true },
                { title: '置顶', scopedSlots: { customRender: 'top' }, align: 'center', width: 100, ellipsis: true },
                { title: '开放状态', scopedSlots: { customRender: 'status' }, align: 'center', width: 100, ellipsis: true },
                { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ]
        };
    },
    created() {
        this.getList();
    },
    methods: {
        //删除
        del(id) {
            this.utils.confirm('删除后无法恢复，是否确认?').then(() => {
                utils.showSpin();
                this.http.delete('/platform/article/culture/del/' + id).then(ret => {
                    if (ret.code == 200) {
                        this.utils.success('操作成功！').then(() => {
                            this.getList();
                        });
                    }
                });
            });
        },
        //获取角色
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/article/culture/list', this.param)
                .then(ret => {
                    this.data = ret.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
            this.getList();
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
